import React, { FC } from 'react'

import clsx from 'clsx'

import { Icon } from 'src/components/atoms/icons'

import { Txt } from '.'

type Props = {
  text: string
  showIcon?: boolean
  iconPlacement?: 'left' | 'right'
  className?: string
}

export const ErrorTxt: FC<Props> = ({
  text,
  showIcon = false,
  iconPlacement = 'right',
  className,
}) => {
  return (
    <div className={className}>
      <span
        className={clsx(
          'tw-inline-flex tw-items-center tw-text-errorRed-default tw-gap-s-4',
          iconPlacement === 'left' ? 'tw-flex-row' : 'tw-flex-row-reverse'
        )}
      >
        {showIcon && <Icon path="info-triangle/soft/fill" className="tw-text-2xl" />}
        <Txt className=" tw-font-bold" sizeType="s">
          {text}
        </Txt>
      </span>
    </div>
  )
}
